import {Popover, withStyles} from '@material-ui/core';

// @ts-ignore
import {Theme} from '@epic-ui/epic';

export const StyledPopover = withStyles((theme: Theme) => ({
    paper: {
        marginTop: theme.spacing(1),
        paddingBottom: theme.spacing(2),
        backgroundColor: theme.palette.background.overlays,

        width: `calc(100% - ${theme.spacing(8)}px)`,

        [theme.breakpoints.up('fsm')]: {
            width: `calc(100% - ${theme.spacing(24)}px)`
        },
        [theme.breakpoints.up('fmd')]: {
            width: 460
        }
    }
}))(Popover);
